module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-380.d9c3dac5.jpg";